'use es6';

import { memo } from 'react';
import { Map as ImmutableMap } from 'immutable';
import { Button } from 'foundations-components/transitional/components/Button';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { getReferenceLabel } from 'reporting-data/v2/dataset/datasetRecords';
import { getPropertyFormatter, isFormattableProperty } from '../../../formatters/propertyFormatter';
import { getRowDataElements } from './CrossTabHelpers';
import { StyledTd } from './CrossTabStyledComponents';
import { jsx as _jsx } from "react/jsx-runtime";
const renderCrossTabuluationRow = (visualization, rowData, index, dataColumns, rowEncodingsWithLabels, originalVisualization, isMobile) => {
  const {
    data,
    dataset,
    values
  } = visualization;
  const crossTabDataset = data.get(dataset);
  const dataOnly = rowData.get('data');
  const rowMetaData = rowData.get('rowMetaData');
  const isColumnSubtotal = rowMetaData.get('isSubtotalsColumn');
  const columnSubtotalField = rowMetaData.get('columnSubtotalField');
  const dataValues = getRowDataElements(visualization, dataOnly, dataColumns, false, {
    isColumnSubtotal,
    columnSubtotalField
  }, originalVisualization);
  const rowLabels = rowEncodingsWithLabels.map(rowEncoding => {
    const rowField = rowEncoding.getIn(['encoding', 'field']);
    const rowInfo = rowMetaData.get(rowField, ImmutableMap({}));
    const rowspan = rowInfo.get('rowspan');
    const colspan = rowInfo.get('colspan');
    const rowValue = rowInfo.get('key');
    const align = rowEncoding.getIn(['encodingLabels', 0, 'align']);
    const maybeFormattableProperty = crossTabDataset.getIn(['properties', rowMetaData.get('isSubtotalsColumn') ? rowValue : rowField]);
    const labelProperty = rowEncoding.getIn(['encoding', 'formattingObject']) && isFormattableProperty(maybeFormattableProperty) ? maybeFormattableProperty.set('formattingObject', rowEncoding.getIn(['encoding', 'formattingObject'])).set('formattingType', rowEncoding.getIn(['encoding', 'formattingType'])) : maybeFormattableProperty;
    const labelPropFormatter = getPropertyFormatter(labelProperty);
    return ImmutableMap({
      label: getReferenceLabel(crossTabDataset, rowField, rowValue, labelPropFormatter(rowValue)),
      align,
      rowspan,
      colspan,
      isRowHeader: true
    });
  }).filter(rowLabel => rowLabel.get('rowspan'));
  const rowEntries = rowLabels.concat(dataValues);
  return values && /*#__PURE__*/_jsx("tr", {
    children: rowEntries.map((val, indx) => {
      const onClick = val.get('onClick');
      return /*#__PURE__*/_jsx(StyledTd, {
        textAlign: val.get('align'),
        rowSpan: val.get('rowspan'),
        colSpan: val.get('colspan'),
        isRowHeader: val.get('isRowHeader'),
        isMobile: isMobile,
        children: /*#__PURE__*/_jsx(TruncateString, {
          children: onClick ? /*#__PURE__*/_jsx(Button, {
            onClick: () => onClick(),
            use: "link",
            "data-test-id": `cross-tab-cell-${index}-${indx}`,
            children: val.get('label')
          }) : /*#__PURE__*/_jsx("span", {
            "data-test-id": `cross-tab-cell-${index}-${indx}`,
            children: val.get('label')
          })
        })
      }, indx);
    })
  }, index);
};
const CrossTabRow = ({
  index,
  visualization,
  rowData,
  dataColumns,
  rowEncodingsWithLabels,
  originalVisualization,
  isMobile
}) => renderCrossTabuluationRow(visualization, rowData, index, dataColumns, rowEncodingsWithLabels, originalVisualization, isMobile);
export default /*#__PURE__*/memo(CrossTabRow);